// /settings — settings shell.
//
// All org members can reach Settings; per-page surfaces self-gate by
// role (billing → admin, audit → owner). Server-side gates on
// /api/billing/* and Clerk's own role checks on org mutations remain
// the authority; this is UX.

import { Outlet, createFileRoute } from "@tanstack/react-router";
import { useOrganization } from "@/lib/auth";
import { LoadingState } from "@/design-system";

export const Route = createFileRoute("/settings")({
  component: SettingsLayout,
});

export function SettingsLayout() {
  const { isLoaded } = useOrganization();

  if (!isLoaded) {
    return <LoadingState />;
  }

  // The settings sub-nav lives in the sidebar (see SidebarNav → SettingsNav);
  // the shell is just the gated outlet.
  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      <Outlet />
    </div>
  );
}
